<div [formGroup]="group">
  <mat-form-field appearance="outline" class="basic-input-field" [ngClass]="config.maxLengthHint ? 'setMargin':''">
    <mat-label class="select-label">{{config.label}}</mat-label>
    <textarea matInput id="{{config.id}}" #textarea [placeholder]="config.placeholder" [maxlength]="config.maxLengthCount" [formControlName]="config.name" [attr.name]="config.name"></textarea>
    @if (config.maxLengthHint) {
      <mat-hint class="w-100">
        <span>{{config.maxLengthText}}</span>
        <span class="float-right"> {{textarea.value?.length || 0}} / {{config.maxLengthCount}}</span>
      </mat-hint>
    }
    @if (group.controls[FormControlName].hasError('minlength') && config.showErrorText) {
      <mat-error>
        Min length validate 6
      </mat-error>
    }
    @if (group.controls[FormControlName].hasError('required') && group.controls[FormControlName].touched && config.showErrorText) {
      <mat-error>
        Field Required Field
      </mat-error>
    }
  </mat-form-field>
</div>